import 'backbone';
import _ from 'underscore';
import config from '@bingads-webui-component-legacy/config/index';

export function decorate(view) {
  return view.extend({
    initialize(...args) {
      view.prototype.initialize(...args);
      this.on('updateAutoTargetEditorSetting', (setting) => {
        this.updateViews.forEach((updateView) => {
          updateView.trigger('updateAutoTargetEditorSetting', setting);
        });
      });
    },

    render(shouldNotCreateDefaultEditor = false) {
      _.bind(view.prototype.render, this)();
      if (!_.isUndefined(this.campaign) && !shouldNotCreateDefaultEditor) {
        this.create();
      }
      return this;
    },

    createAndRefocus(shouldValidate) {
      const isDSAMixedModeCampaignEnabled = _.result(config.get('Permissions'), 'IsDSAMixedModeCampaignEnabled', false);
      const originalCreateAndRefocus = _.bind(view.prototype.createAndRefocus, this);

      if (isDSAMixedModeCampaignEnabled && this.options.submitDSASettings) {
        return this.options.submitDSASettings()
          .then((result) => {
            if (result) {
              originalCreateAndRefocus(shouldValidate);
            }
          });
      }

      return originalCreateAndRefocus(shouldValidate);
    },
  });
}
